import React from 'react';

export default function ComEvalList({ tab, evntList, selectEvnt, setSelectEvnt, companyList, selectCompany, setSelectCompany }: any) {
  return (
    <>
      {tab === 1 ? evntList?.map((evnt: any, idx: number) => {
        return (
          <div key={idx} onClick={() => setSelectEvnt(evnt.evntSeq)} className='w-[260px] sm:w-[308px] md:w-[750px]'>
            <div className={selectEvnt === evnt.evntSeq ? `bg-[#FFEEEF] rounded-[10px] md:rounded-[25px] pl-10 pb-5 pt-5 mt-16 md:pl-[25px] md:pb-[12px] md:pt-[12px] md:mt-[40px]`
              : `pl-10 pb-5 mt-21 md:pl-[25px] md:pb-[12px] md:mt-[52px]`}>
              <p className={selectEvnt === evnt.evntSeq ? `text-15 leading-18 md:text-37 md:leading-[45px] font-preBold truncate text-point`
                : `text-15 leading-18 md:text-37 md:leading-[45px] font-preBold truncate`}>{evnt.evntNm}</p>
              <p className={selectEvnt === evnt.evntSeq ? `text-14 leading-17 mt-8 md:text-35 md:leading-[42px] md:mt-[20px] text-point`
                : `text-14 leading-17 mt-8 md:text-35 md:leading-[42px] md:mt-[20px]`}>{evnt.prepStrtDt} ~ {evnt.dmlnEndDt} / {evnt.exbtPlc}</p>
            </div>
            {idx !== (evntList.length - 1) && <div className='border border-x-0 border-t-0 border-[#CACACA] w-full mt-23 md:mt-[57px]' />}
          </div>)
      }) : null}
      {tab === 2 ? companyList.length > 0 ? companyList?.map((company: any, idx: number) => {
        return (
          <div key={idx} onClick={() => setSelectCompany(company)} className='w-[260px] sm:w-[308px] md:w-[750px]'>
            <div className={selectCompany.cmpnySeq === company.cmpnySeq ? `bg-[#FFEEEF] rounded-[10px] md:rounded-[25px] pl-10 pb-5 pt-5 mt-16 md:pl-[25px] md:pb-[12px] md:pt-[12px] md:mt-[40px]`
              : `pl-10 pb-5 mt-21 md:pl-[25px] md:pb-[12px] md:mt-[52px]`}>
              <p className={selectCompany.cmpnySeq === company.cmpnySeq ? `text-15 leading-18 md:text-37 md:leading-[45px] font-preBold truncate text-point`
                : `text-15 leading-18 md:text-37 md:leading-[45px] font-preBold truncate`}>{company.cmpnyNm}</p>
              <p className={selectCompany.cmpnySeq === company.cmpnySeq ? `text-14 leading-17 mt-8 md:text-35 md:leading-[42px] md:mt-[20px] text-point`
                : `text-14 leading-17 mt-8 md:text-35 md:leading-[42px] md:mt-[20px]`}>{company.sctrGbNm} / {company.representative} / {company.companyRegNum}</p>
            </div>
            {idx !== (evntList.length - 1) && <div className='border border-x-0 border-t-0 border-[#CACACA] w-full mt-23 md:mt-[57px]' />}
          </div>)
      }) : <p className={`text-15 leading-18 md:text-37 md:leading-[45px] font-preBold truncate`}>신고서를 등록한 업체가 없습니다.</p> : null}
    </>
  );
};